
import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import MDBox from '../../../components/MDBox';
import MDInput from '../../../components/MDInput';
import MDTypography from '../../../components/MDTypography';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';


const AvatarUploadField = ({ value, onChange, error }) => {
  const [preview, setPreview] = React.useState(null);

  React.useEffect(() => {
    if (value instanceof File) {
      const objectUrl = URL.createObjectURL(value);
      setPreview(objectUrl);
      return () => URL.revokeObjectURL(objectUrl);
    } else {
      setPreview(null);
    }
  }, [value]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      onChange(file);
    }
  };

  return (
    <MDBox
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      border="1px dashed"
      borderColor={error ? "error.main" : "grey.400"}
      borderRadius="lg"
      p={3}
      sx={{
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        backgroundColor: error ? "error.light" : "transparent",
        "&:hover": {
          borderColor: "info.main",
          backgroundColor: "grey.100",
        },
      }}
      component="label"
    >
      <input
        type="file"
        hidden
        accept="image/*"
        onChange={handleFileChange}
        value="" // Controlled via onChange
      />

      {preview ? (
        <MDBox position="relative" display="flex" flexDirection="column" alignItems="center">
          <MDBox
            component="img"
            src={preview}
            alt="Avatar Preview"
            width="100px"
            height="100px"
            borderRadius="50%"
            sx={{ objectFit: "cover", mb: 2, border: "2px solid", borderColor: "white", boxShadow: 3 }}
          />
          <MDTypography variant="button" color="info" fontWeight="bold">
            تغيير الصورة
          </MDTypography>
        </MDBox>
      ) : (
        <>
          <MDBox
            component="span"
            fontSize="2rem"
            color={error ? "error" : "text"}
            mb={1}
          >
             ☁️
          </MDBox>
          <MDTypography variant="body2" color="text" fontWeight="medium">
             اضغط هنا لرفع صورة
          </MDTypography>
          <MDTypography variant="caption" color="text" opacity={0.6}>
            (PNG, JPG - Max 2MB)
          </MDTypography>
        </>
      )}
    </MDBox>
  );
};

const TeamLeaderStep = () => {
  const { control, formState: { errors } } = useFormContext();

  return (
    <MDBox>
      
      <Grid container spacing={3}>
        <Grid item size={{ xs: 12, md: 6 }}>
          <Controller
            name="user_name"
            control={control}
            render={({ field }) => (
              <MDInput
                {...field}
                label="الاسم"
                fullWidth
                error={!!errors.user_name}
                helperText={errors.user_name?.message}
              />
            )}
          />
        </Grid>
        <Grid item size={{ xs: 12, md: 6 }}>
          <Controller
            name="email"
            control={control}
            render={({ field }) => (
              <MDInput
                {...field}
                label="البريد الالكتروني"
                type="email"
                fullWidth
                error={!!errors.email}
                helperText={errors.email?.message}
              />
            )}
          />
        </Grid>
        <Grid item size={{ xs: 12, md: 6 }}>
          <Controller
            name="password"
            control={control}
            render={({ field }) => (
              <MDInput
                {...field}
                label="كلمة المرور"
                type="password"
                fullWidth
                error={!!errors.password}
                helperText={errors.password?.message}
              />
            )}
          />
        </Grid>
        <Grid item size={{ xs: 12, md: 6 }}>
          <Controller
            name="password_confirmation"
            control={control}
            render={({ field }) => (
              <MDInput
                {...field}
                label="تاكيد كلمة المرور"
                type="password"
                fullWidth
                error={!!errors.password_confirmation}
                helperText={errors.password_confirmation?.message}
              />
            )}
          />
        </Grid>
        <Grid item size={{ xs: 12, md: 6 }}>
          <Controller
            name="phone"
            control={control}
            render={({ field }) => (
              <MDInput
                {...field}
                label="رقم الهاتف"
                fullWidth
                error={!!errors.phone}
                helperText={errors.phone?.message}
              />
            )}
          />
        </Grid>
        <Grid item size={{ xs: 12, md: 6 }}>
          <Controller
            name="gender"
            control={control}
            render={({ field }) => (
              <MDInput
                {...field}
                select
                label="الجنس"
                fullWidth
                error={!!errors.gender}
                helperText={errors.gender?.message}
                sx={{
                  "& .MuiInputBase-root": {
                    padding: "12px !important",
                 },
                  
                }}
              >
                <MenuItem value={1}>ذكر</MenuItem>
                <MenuItem value={2}>انثى</MenuItem>
                
              </MDInput>
            )}
          />
        </Grid>
         <Grid item size={{ xs: 12, md: 6 }}>
             <LocalizationProvider dateAdapter={AdapterDayjs}>
                 <Controller
                    name="birth_date"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <DatePicker
                        label="تاريخ الميلاد"
                        value={value}
                        size="medium"
                        onChange={onChange}
                         slotProps={{
                  textField: {
                    fullWidth: true,
                    error: !!errors.date,
                    helperText: errors.date,
                    sx: {
                      "& .MuiOutlinedInput-root": {
                        padding: "2px !important",
                        
                       
                        color: "text.main",
                        fontSize: ".85rem",
                      },
                      "& .MuiOutlinedInput-input": {
                        padding: "5px 10px !important",
                        height: "auto",
                        color: "text.main",
                        WebkitTextFillColor: "text.main",
                        fontSize: ".85rem",
                      },
                      "& .MuiInputBase-input": {
                        color: "text.main",
                        WebkitTextFillColor: "text.main",
                        fontSize: ".85rem",
                      },
                      "& .MuiPickersSectionList-root": {
                        color: "text.main",
                        fontSize: ".85rem",
                        padding: "12px 10px !important",
                        
                      },
                      "& .MuiPickersSectionList-section": {
                        color: "text.main",
                        fontSize: ".85rem",
                      },
                      "& .MuiPickersSectionList-sectionContent": {
                        color: "text.main",
                        fontSize: ".85rem",
                      },
                      "& .MuiDateSectionInput-input": {
                        color: "text.main",
                        fontSize: ".85rem",
                      },
                      "& input": {
                        color: "text.main",
                        WebkitTextFillColor: "text.main",
                        fontSize: ".85rem",
                      },
                      "& .MuiInputLabel-root": {
                        transform: "translate(14px, 6px) scale(1)",
                        color: "text.main",
                        fontSize: ".85rem",
                        "&.MuiInputLabel-shrink": {
                          transform: "translate(14px, -8px) scale(0.75)",
                        },
                      },
                     "& .MuiPickersOutlinedInput-notchedOutline": {
                      borderColor: "text.border",
                    },
                      
                    },
                  },
                  openPickerButton: {
                    sx: {
                      color: "text.main",
                      padding: "4px",
                    },
                  },
                  openPickerIcon: {
                    sx: {
                      color: "text.main",
                      fill: "text.main",
                      fontSize: "1.1rem",
                    },
                  },
                }}

                      />
                    )}
                  />
             </LocalizationProvider>
        </Grid>
     <Grid item size={{ xs: 12, md: 6 }}>
          <Controller
            name="avatar"
            control={control}
            render={({ field: { value, onChange } }) => (
                <AvatarUploadField 
                    value={value} 
                    onChange={onChange} 
                    error={errors.avatar} 
                />
            )}
          />
           {errors.avatar && (
            <MDTypography variant="caption" color="error" sx={{ mt: 1, display: 'block', textAlign: 'center' }}>
                {errors.avatar?.message?.toString()}
            </MDTypography>
           )}
        </Grid>
      </Grid>
    </MDBox>
  );
};

export default TeamLeaderStep;
